import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import H1 from "./H1/H1";
import "./ParceirosDaRede.css"; // Import the CSS file for styling

const PartnerLogo = ({ partner, index }) => {
  const [failed, setFailed] = useState(false);
  const altText = partner.name
    ? `Logo ${partner.name}`
    : `Logo parceiro ${index + 1}`;
  const label = partner.name || `Parceiro ${index + 1}`;

  const content = failed ? (
    <div
      className="h-24 w-32 flex items-center justify-center bg-gray-100 border border-dashed border-gray-300 text-gray-500 text-xs text-center px-2 rounded"
      aria-label={altText}
    >
      {label}
    </div>
  ) : (
    <img
      src={partner.logo}
      alt={altText}
      className="h-24 object-contain"
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );

  if (!partner.link) {
    return <div className="m-1">{content}</div>;
  }

  return (
    <a
      href={partner.link}
      target="_blank"
      rel="noreferrer noopener"
      className="m-1"
    >
      {content}
    </a>
  );
};

const ParceirosDaRede = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const docRef = doc(db, "content", "parceiros");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && Array.isArray(docSnap.data().partners)) {
          setPartners(docSnap.data().partners.filter((p) => p && p.logo));
        }
      } catch (err) {
        console.error("Erro ao carregar parceiros:", err);
      }
    };

    fetchPartners();
  }, []);

  return (
    <div className="parceiros-da-rede">
      <div className="max-w-7xl mx-auto">
        <div className="title-area">
          <H1 text="Parceiros da Rede" bgColor="grey" fontColor="gray" />
        </div>
        <div className="px-4 md:px-0 logos-area max-w-7xl mx-auto flex flex-wrap justify-center">
          {partners.map((partner, index) => (
            <PartnerLogo
              key={partner.id || partner.logo || index}
              partner={partner}
              index={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ParceirosDaRede;
